import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { useModals } from 'almanac-ui/Modal'
import { ShopifyIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { CardButtons } from './CardButtons'
import { ShopifyInitialization } from 'components/IntegrationInitialization/ShopifyInitialization/ShopifyInitialization'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { Shopify } from 'blaze-ui/icons/20'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useBlogIntegrations } from 'hooks/useBlogIntegrations'

interface ShopifyCardProps {
  integrations?: ShopifyIntegration[]
  canConnect?: boolean
  isDisconnected?: boolean
}

export const ShopifyCard = ({ integrations = [], canConnect, isDisconnected = false }: ShopifyCardProps) => {
  const { openModal, closeModal } = useModals()
  const { initiateOauth } = useInitiateOauth()
  const shopifyEnabled = useFlipperFlag('shopify_integration')
  const { getRestrictionMessage } = useBlogIntegrations()

  const restrictionMessage = getRestrictionMessage(ExternalIntegrationEnum.Shopify)
  const canConnectShopify = canConnect ?? !restrictionMessage

  const handleConnect = () => {
    openModal(() => (
      <ShopifyInitialization
        onConnect={(shopDomain: string) => {
          closeModal()
          initiateOauth(ExternalIntegrationEnum.Shopify, undefined, undefined, undefined, shopDomain)
        }}
      />
    ))
  }

  if (!shopifyEnabled) return null

  return (
    <ExternalIntegrationCard
      title="Shopify"
      description="Connect your Shopify store to publish blog content directly from Blaze"
      integrations={integrations}
      icon={<Shopify size={20} />}
      isDisabled={!canConnectShopify}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={handleConnect}
          provider={ExternalIntegrationEnum.Shopify}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisabled={!canConnectShopify}
          tooltipMessage={restrictionMessage || undefined}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
